import './allNotes.css';
import { NoteHistory } from '../../components/NoteHistory/noteHistory';

const AllNotes = () => {
    return (
        <>
            <NoteHistory></NoteHistory>
        </>
    );
};
export default AllNotes;
